<div class="wrapper">
  @if (showUploadPhotosInfo) {
    <span class="upload-photos-info">
      {{ 'i18n.gallery.uploadPhotos.info' | translate }}
    </span>
  }
  <div class="thumbnails" #thumbnailsWrapper (window:resize)="onResize()">
    @for (imagesChunk of galleryImages | paginate: {
      id: paginationId,
      itemsPerPage: 1,
      currentPage: currentPage()
      }; track imagesChunk) {
      @for (image of imagesChunk; track trackById($index, image)) {
        <div class="thumbnail-container"
            [ngClass]="{'used': imageIsUsed(image.id),
                'selected': imageIsSelected(image.id) }">
          <img class="thumbnail"
              [ngClass]="{
                  load: loadedImages.indexOf(image) === -1,
                  loaded: loadedImages.indexOf(image) > -1
              }"
            (load)="loadedImages.push(image)"
            [attr.data-imageId]="image.id"
            [src]="getThumbnailUrl(image)"
            [style.width]="getThumbnailWidth(image)"
            [style.height]="getThumbnailHeight()"
            (dragstart)="dragStart(image.id)"
            (click)="!imageIsUsed(image.id) ? imageClicked.emit(image.id) : ''"
            />
        </div>
      }
    }
  </div>

  <pagination-controls  [id]="paginationId"
    (pageChange)="pageChanged($event)"
    maxSize="5"
    directionLinks="true"
    autoHide="true"
    previousLabel=""
    nextLabel=""
    screenReaderPaginationLabel="Pagination"
    screenReaderPageLabel="page"
    screenReaderCurrentLabel="You're on page"
  ></pagination-controls>

  @if (progress.inProgress) {
    <mat-progress-bar
      mode="determinate"
      [value]="galleryService.uploadPercentage"
    color="accent"></mat-progress-bar>
  }
  @if (progress.inProgress) {
    <span class="upload-progress">
      <translate [key]="'i18n.gallery.uploadProgress'"
        [plural]="galleryService.imagesToUpload || 1"
               [values]="{ current: galleryService.imagesUploaded,
                           total: galleryService.imagesToUpload || 1 }"
      ></translate>
    </span>
  }
</div>
